import { Injectable } from "@angular/core";

import { Observable } from "rxjs";

import { MaalerType } from "../model/maaler-type.model";
import { MaalerTypeRepository } from "./maaler-type.repository";

@Injectable({ providedIn: "root" })
export class MaalerTypeService {
    constructor(private readonly maalerTypeRepository: MaalerTypeRepository) {}

    public hentMaalerTyper(): Observable<MaalerType[]> {
        return this.maalerTypeRepository.hentMaalerTyper();
    }
}
